import React from "react";
import { connect } from "react-redux";
import {
  registrarUsuario,
  editarUsuario,
} from "../../components/usuario/UsuarioService";
import axios from "axios";
import {
  URL as URLService,
  getAuthorizationHeader,
  getAuthorizationHeaderUpload,
  aparienciaFirmaUsuario,
  admin,
  idEmpresa,
  username,
} from "../../constans/constants";
import Cookies from "universal-cookie";

import Resizer from "react-image-file-resizer";
import { logout } from "../login/SesionService";
import { validateForm } from "../../constans/validationUtils";
import validarImagen from "../seguridad/ValidadorImagen";
import DropzoneComponent from "../componentes/DropzoneComponent";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import {
  mostrarErroresEnFormulario,
  configurarLimpiezaAutomatica,
  integrarConHandleInput,
  integrarConChkClick,
} from "../../constans/form-error-utils";
import BusquedaUsuario from "../componentes/BusquedaUsuario";
import ComponenteVacio from "../../components/componentes/avisos/ComponenteVacio";
import ModalEnviarNotificacion from "./ModalEnviarNotificacion";
import { getNotificacion} from "./NotificacionService";
import Multiselect from "../componentes/forms/Multiselect";

class Notificacion extends React.Component {
  constructor(props) {
    super(props);

    const originalHandleInput = this.handleInput;
    this.handleInput = integrarConHandleInput(this, originalHandleInput);

    this.state = {
      titulo: "",
      resumen: "",
      duracion: "",
      tipo: "",
      tituloRep: "",
      duracionRep: "",
      errors: {
        titulo: null,
        resumen: null,
        duracion: null,
        tipo: null,
        tituloRep: null,
        duracionRep: null,
      },
      usuariosSeleccionados: [],
      showErrors: false,
      tipoNotificaciones: [],
      codigoTipoNotificacion: null,
      mostrarModalConfirmacion: false,
      gruposUsuarios: [],
      gruposSeleccionados: [],
      idsGruposSeleccionados: [],
      desarrollo: "",
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "",
    };

    this.formRef = React.createRef();
  }

  reglasValidacionCampos = {
    titulo: [{ required: true, message: "Campo obligatorio" }],
    resumen: [{ required: true, message: "Campo obligatorio" }],
    duracion: [{ required: true, message: "Debe seleccionar una duración" }],
    codigoTipoNotificacion: [{ required: true, message: "Debe seleccionar un tipo" }],
  };

async componentDidMount() {
  configurarLimpiezaAutomatica();
  this.obtenerDatosIniciales();

if (this.props.location.tipoAccion === "edit") {
  try {
    const data = await getNotificacion(this.props.location.idNotificacion);

    this.setState({
      titulo: data.datos.titulo,
      resumen: data.datos.resumen,
      duracion: data.datos.duracionDias,
      codigoTipoNotificacion: data.datos.tipo.codigo,
      desarrollo: data.datos.desarrollo,
      usuariosSeleccionados: data.datos.listaUsuariosReceptores.map(u => ({
        cedula: u.cedula,
        nombreApellido: u.nombre,
        usuario: u.username
      }))
    });
  } catch (error) {
    console.error("Error obteniendo la notificación:", error);
  }
}
  axios
      .get(
        URLService + "grupos/empresa/" + idEmpresa() + "/getAll",
        getAuthorizationHeader()
      )
      .then((res) => {
        if (res.data.error == false) {
          this.setState({ gruposUsuarios: res.data.datos });
        }
      }, error => {
        if (error.response.status === 401) {
          logout();
        }
        return error;
      });
}


  obtenerDatosIniciales = async () => {
    try {
      const response = await axios.get(
        `${URLService}notificaciones/tipo-notificaciones`,
        getAuthorizationHeader()
      );
      this.setState({ tipoNotificaciones: response.data.datos });
      return response.data;
    } catch (error) {
      console.error("Error al marcar notificación como leída:", error);
      throw error;
    }
  };

  handleUsuariosChange = (datos) => {
    this.setState({ usuariosSeleccionados: datos });
  };

  handleInput = (e) => {
    let name = e.target.name;
    let val = e.target.value;
    this.setState((prevState) => ({
      errors: {
        ...prevState.errors,
        [name]: null,
      },
      [name]: val,
    }));
  };

  validarCamposFormulario = () => {
    let { isValid, errors } = validateForm(
      this.state,
      this.reglasValidacionCampos
    );
    return { isValid, errors };
  };
  handleGrupoChange = (values) => {
  const ids = values.map(v => v.value); 

  this.setState({
    gruposSeleccionados: values,
    idsGruposSeleccionados: ids,
  });
};

  handleEliminarUsuario = (cedula) => {
    this.setState((prev) => ({
      usuariosSeleccionados: prev.usuariosSeleccionados.filter(
        (u) => u.cedula !== cedula
      ),
    }));
  };
  abrirModal = () => {
    this.setState({ mostrarModalConfirmacion: true });
  };

  cerrarModal = () => {
    this.setState({ mostrarModalConfirmacion: false });
  };
handleSubmit = async (event) => {
  if (event && event.preventDefault) {
    event.preventDefault();
  }

  const { isValid, errors } = this.validarCamposFormulario();

  if (!isValid) {
    // Mostrar los errores de validación
    this.setState({ 
      errors,
      showErrors: true 
    });
    mostrarErroresEnFormulario(errors);
    
    
    // Retornar error específico para que el modal no se cierre
    return Promise.reject(new Error("Por favor, complete todos los campos obligatorios"));
  }

  // Validación adicional: verificar que hay usuarios seleccionados
/*   if (this.state.usuariosSeleccionados.length === 0) {
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: "Debe seleccionar al menos un usuario para enviar la notificación",
      mensajeFlashSeverity: "error",
    });
    return Promise.reject(new Error("Debe seleccionar al menos un usuario"));
  }
 */
  // Si llegamos aquí, el formulario es válido
  mostrarErroresEnFormulario({});

  const receptores = this.state.usuariosSeleccionados.map(
    (tipo) => tipo.cedula
  );

  const payload = {
    titulo: this.state.titulo,
    resumen: this.state.resumen,
    desarrollo: this.state.desarrollo,
    duracionDias: parseInt(this.state.duracion, 10) || 0,
    codigoNotificacion: this.state.codigoTipoNotificacion,
    usernameCreador: username(),
    idEmpresa: idEmpresa(),
    ciReceptores: receptores,
    idGruposReceptores: this.state.idsGruposSeleccionados,
  };

  try {
    // Guardar notificación
    const res = await axios.post(
      URLService + "notificaciones/guardar",
      payload,
      getAuthorizationHeader()
    );
    
    
    if (res.data.error) {
      throw new Error(res.data.mensaje || "Error al guardar la notificación");
    }

    const idNotificacion = res.data.datos.id;

    // Enviar notificación
    const resEnviar = await axios.post(
      `${URLService}notificaciones/${idNotificacion}/enviar`,
      {},
      getAuthorizationHeader()
    );
    
     this.props.history.push({
            pathname: `/notificaciones/todos`,
            state: {
              mensajeFlash: "Notificación guardada y enviada correctamente",
              mostrarMensajeFlash: true,
              mensajeFlashSeverity:"exito",
            }
          });
    // Retornar éxito para que el modal sepa que puede cerrarse
    return Promise.resolve();
    
  } catch (error) {
    console.error("❌ Error en el proceso de guardar/enviar", error);
    
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: "Ocurrió un error al guardar o enviar",
      mensajeFlashSeverity: "error",
    });

    // Retornar error para que el modal no se cierre
    return Promise.reject(error);
  }
};

guardarBorrador = async (event) => {
  if (event && event.preventDefault) {
    event.preventDefault();
  }


  // Validación adicional: verificar que hay usuarios seleccionados
  if (this.state.usuariosSeleccionados.length === 0) {
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: "Debe seleccionar al menos un usuario para enviar la notificación",
      mensajeFlashSeverity: "error",
    });
    return Promise.reject(new Error("Debe seleccionar al menos un usuario"));
  }

  // Si llegamos aquí, el formulario es válido
  mostrarErroresEnFormulario({});

  const receptores = this.state.usuariosSeleccionados.map(
    (tipo) => tipo.cedula
  );

  const payload = {
    titulo: this.state.titulo,
    resumen: this.state.resumen,
    desarrollo: this.state.desarrollo,
    duracionDias: parseInt(this.state.duracion, 10) || 0,
    codigoNotificacion: this.state.codigoTipoNotificacion,
    usernameCreador: username(),
    idEmpresa: idEmpresa(),
    ciReceptores: receptores,
    idGruposReceptores: this.state.idsGruposSeleccionados,
  };

  try {
    // Guardar notificación
    const res = await axios.post(
      URLService + "notificaciones/guardar",
      payload,
      getAuthorizationHeader()
    );
    
     this.props.history.push({
            pathname: `/notificaciones/todos`,
            state: {
              mensajeFlash: "Notificación guardada como borrador correctamente",
              mostrarMensajeFlash: true,
              mensajeFlashSeverity:"exito",
            }
          });

  } catch (error) {
    console.error("❌ Error en el proceso de guardar/enviar", error);
    
    this.setState({
      mostrarMensajeFlash: true,
      mensajeFlash: "Ocurrió un error al guardar o enviar",
      mensajeFlashSeverity: "error",
    });

  }
};

  renderTablaUsuarios = () => {
    return (
      <div className="component-table">
        <h4 className="table-title"> Miembros del grupo </h4>
        <div className="responsive-table">
          <table>
            <thead>
              <tr>
                <th>Nombre completo</th>
                <th>Cédula de identidad</th>
                <th>Usuario</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {this.state.usuariosSeleccionados.map((elemento) => {
                return (
                  <tr key={elemento.cedula}>
                    <td>{elemento.nombreApellido}</td>
                    <td>{elemento.cedula}</td>
                    <td>{elemento.usuario}</td>
                    <td>
                      <div className="table-actions">
                        <button
                          onClick={() =>
                            this.handleEliminarUsuario(elemento.cedula)
                          }
                          className="table-icon open-dialog"
                        >
                          <span className="material-symbols-outlined">
                            {" "}
                            delete{" "}
                          </span>
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl={"/notificaciones/todos"}
                breadcrumbs={[
                  { label: "Notificaciones", path: "/notificaciones/todos" },
                  {
                    label:
                      this.props.location.tipoAccion !== "edit"
                        ? "Crear Notificación"
                        : "Editar Notificación",
                    path: "",
                  },
                ]}
              />

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">
                    {this.props.location.tipoAccion === "edit" ? "Editar Notificación" : "Crear Notificación"}
                  </h1>
                  <p className="page-description">
                    {" "}
                    Complete el siguiente formulario con los datos
                    correspondientes{" "}
                  </p>
                </div>
              </div>
            </div>
          </header>
          <div className="wrapperContent">
            <div className="page-container card">
              <div className="component-form">
                <div className="page-container">
                  <div className="component-content card">
                    <form
                      className="form container-sm"
                    >
                      <div className="form-group__inline">
                        <div className="form-group">
                          <input
                            type="text"
                            name="titulo"
                            className="form-input"
                            placeholder=""
                            value={this.state.titulo}
                            onChange={this.handleInput}
                          />
                          <label htmlFor="titulo" className="form-label">
                            Título
                          </label>
                        </div>

                        <div className="form-group">
                          <input
                            type="text"
                            name="resumen"
                            className="form-input"
                            placeholder=""
                            value={this.state.resumen}
                            onChange={this.handleInput}
                          />
                          <label htmlFor="resumen" className="form-label">
                            Resumen
                          </label>
                        </div>

                        <div className="form-group">
                          <input
                            type="number"
                            name="duracion"
                            className="form-input"
                            placeholder=""
                            value={this.state.duracion}
                            onChange={this.handleInput}
                            min="1"
                          />
                          <label className="form-label">Duración (días)</label>
                        </div>

                        <div className="form-group">
                          <select
                            name="codigoTipoNotificacion"
                            className="form-select"
                            value={this.state.codigoTipoNotificacion}
                            onChange={this.handleInput}
                          >
                            <option value="">Seleccione un tipo</option>
                            {this.state.tipoNotificaciones.map((tipo) => (
                              <option key={tipo.id} value={tipo.codigo}>
                                {tipo.nombre}
                              </option>
                            ))}
                          </select>
                          <label className="form-label">
                            Tipo de notificación
                          </label>
                        </div>
                      </div>

                      <hr />

                      <h3 className="form-subtitle">
                        Representaciones de la notificación
                      </h3>
<form className="seleccionDestinatarios">
  <Multiselect
    options={this.state.gruposUsuarios.map((g) => ({
      value: g.idGrupo,        // ID del grupo
      label: g.descripcion,    // texto que se muestra
    }))}
    initialValues={this.state.gruposSeleccionados}
    onChange={this.handleGrupoChange}
    placeholder="Seleccionar grupos de usuarios"
    name="gruposUsuarios"
  />
</form>
                      <div className="form-group__inline">
                        <BusquedaUsuario
                          selectedUsers={this.state.usuariosSeleccionados}
                          onSelectedUsersChange={this.handleUsuariosChange}
                        />
                      </div>
                      {this.state.usuariosSeleccionados.length == 0 ? (
                        <ComponenteVacio />
                      ) : (
                        this.renderTablaUsuarios()
                      )}
                      {/*                      <div className="component-colapsable">
                        <details className="card-collapse" name="collapse-text">
                          <summary className="card-summary">
                            {" "}
                            Agregar imagen{" "}
                          </summary>
                          <div className="collapse-content">
                            <div data-include="component-carga-documento"></div>
                          </div>
                        </details>
                      </div> */}
                      <div className="component-colapsable">
                        <details className="card-collapse" name="collapse-text">
                          <summary className="card-summary">
                            {" "}
                            Agregar descripción{" "}
                          </summary>
                          <div className="collapse-content">
                            <div className="form-group">
                              <textarea
                                name="desarrollo"
                                rows="4"
                                className="form-textarea"
                                value={this.state.desarrollo}
                                onChange={this.handleInput}
                              ></textarea>
                              <label className="form-label-textarea">
                                Descripción
                              </label>
                            </div>
                          </div>
                        </details>
                      </div>

                      <div className="form-actions">
                        <button
                          type="button"
                          className="btn-medium btn-link"
                          onClick={() => this.props.history.push('/notificaciones/todos')}
                        >
                          Cancelar
                        </button>
                        <button
                          type="button"
                          className="btn-medium btn-primary-tonal"
                          onClick={this.guardarBorrador}
                        >
                          Guardar borrador
                        </button>
                        <button
                        type="button"
                          onClick={this.abrirModal}
                          className="btn-medium btn-primary open-dialog"
                        >
                          Continuar
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ModalEnviarNotificacion
          open={this.state.mostrarModalConfirmacion}
          onClose={this.cerrarModal}
          onConfirm={this.handleSubmit}
        />
        <MensajeFlash
          visible={this.state.mostrarMensajeFlash}
          mensaje={this.state.mensajeFlash}
          severity={this.state.mensajeFlashSeverity}
        />
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  registrarUsuario: (value) => dispatch(registrarUsuario(value)),
  editarUsuario: (value) => dispatch(editarUsuario(value)),
});
const mapStateToProps = (state) => ({
  sessionData: state.sessionData,
});

export default connect(mapStateToProps, mapDispatchToProps)(Notificacion);
